import React, { useState } from "react";
import cloneDeep from "lodash.clonedeep";
import OutsideClickHandler from 'react-outside-click-handler';

//options é um array com strings ou objetos no com o formato { descricao: string, key: string }
//optionsSelected é um array de string ou de options
//onSelect é um callback no formato (options) => any
//onInputChange é um callback no formato (term: string) => any
//disabled boolean
//placeholder string
export function AutocompleteMultiselect({ options, optionsSelected, onSelect, onInputChange, disabled, placeholder }) {
  const [focused, setFocused] = useState(false);

  const onOptionToogleMultiselect = (option) => {
    const index = optionsSelected.findIndex((op) => op.key == option.key);
    if (index != -1) {
      const optionsCopy = cloneDeep(optionsSelected);

      if(optionsSelected[index].id && optionsCopy[index]._destroy) {
        optionsCopy[index]._destroy = false
      } else if(optionsSelected[index].id && !optionsCopy[index]._destroy) {
        optionsCopy[index]._destroy = true
      } else {
        optionsCopy.splice(index, 1);
      }

      onSelect(optionsCopy);
      return;
    }

    onSelect(optionsSelected.concat(option));
  }

  return (
    <OutsideClickHandler onOutsideClick={() => setFocused(false)}>
      <div>
        <div className="multiselect__container">
          <div className="multiselect__preview">
          </div>
          <div className="multiselect__input-container">
            <input type="text" className="multiselect__search"
              disabled={disabled}
              onChange={(e) => onInputChange(e.target.value)}
              onFocus={() => setFocused(true)}
              placeholder={placeholder} />
          </div>
        </div>
        {focused && (
          <div>
            <div >
              <ul className="multiselect__list">
                {options?.map((option) => {
                  const optionSelected = optionsSelected?.find((op) => op.key == option.key);
                  const checked = !!optionSelected && !optionSelected._destroy

                  return (
                    <li key={option.key}>
                      <label>
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={() => onOptionToogleMultiselect(option)}
                        />
                        <span>{option.descricao}</span>
                      </label>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        )}
      </div>
    </OutsideClickHandler>
  )
}